const paymentTypes = require("../../../../../../../constants/paymentTypes");
const upperFirst = require("mn-utils/upperFirst");
const {
  DisplayDataMerchant,
  DisplayIdMerchant,
  DisplayDateTimeMerchant,
  DisplayAmountFCMerchant,
  DisplayAmountMerchant
} = require("../../../../../../dumb/DisplayData");
const React = require("react");

module.exports = (props) => {
  const data = props.data || {};

  const {
    id,
    app_name: appUrl,
    transaction_type: kind,
    status,
    payment_method,
    customer_email,
    cc_code,
    cc_amount,
    fiat_code,
    fiat_amount,
    client_quote_id,
    created_at,
  } = data;

  const paymentMethodName = paymentTypes[payment_method];

  return (
    <div
      className={`w h layoutRow fhaS fvaC rlv lh fw7 f12 c2 tc lts0em
           ph20 (ph10|w1/6)>1 bgF6F6F6.even` + (props.index % 2 === 1 ? ' even' : '')}
      aria-rowindex={props.index}
    >
      <div
        className="tl pl25@d2 lh130%"
        aria-colindex="0"
      >
        <div>
          {upperFirst(kind || '').split('_').join(' ')}
        </div>
        <div className="fhaS mt3 fw4 c717275">
          {paymentMethodName
            ? paymentMethodName
            : upperFirst(payment_method || '').replace('_', ' ')
          }
        </div>
      </div>
      <div aria-colindex="1">
        <DisplayDataMerchant>
          {customer_email}
        </DisplayDataMerchant>
      </div>
      <div aria-colindex="2">
        <DisplayDataMerchant>
          {appUrl}
        </DisplayDataMerchant>
      </div>
      <div aria-colindex="3">
        <DisplayIdMerchant>
          {client_quote_id}
        </DisplayIdMerchant>
      </div>
      <div aria-colindex="4">
        <DisplayDateTimeMerchant
          date={created_at}
        />
      </div>
      <div aria-colindex="4">
        {fiat_amount && cc_amount ? (
          <DisplayAmountFCMerchant
            fiat={{amount: fiat_amount, symbol: fiat_code}}
            crypto={{amount: cc_amount, symbol: cc_code}}
          />
        ) : fiat_amount
          ? (
            <DisplayAmountMerchant
              amount={fiat_amount}
              symbol={fiat_code}
              type="fiat"
            />
          ) : cc_amount
            ? (
              <DisplayAmountMerchant
                amount={cc_amount}
                symbol={cc_code}
                type="coin"
              />
            ) : '-'
        }
      </div>
      {/*<div aria-colindex="5">*/}
      {/*  <DisplayStatusTrx status={status} />*/}
      {/*  */}
      {/*</div>*/}
    </div>
  );
};
